
import './App.css';
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import NavHeader from "./NavHeader";
import LoadingSpinner from "./components/Helpers/LoadingSpinner";
import Table from "./components/Table";
import { Button, Row, Col, Modal, Form, InputGroup, ButtonGroup } from "react-bootstrap";


function CustomerShow() {
  const [customer, setCustomer] = useState();
  const [unassignedDevices, setUnassignedDevices] = useState();
  const [deviceID, setDeviceID] = useState();

  let { id } = useParams();

  const getCustomer = () => {
    axios
    .get(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/customer/${id}.json`)
    .then(({ data }) => {
      setCustomer(data.customer)
    })
  }

  const getUnassignedDevices = () => {
    axios
    .get(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/ha_devices/unassigned.json`)
    .then(({ data }) => {
      setUnassignedDevices(data)
    })
  }

  const assignDevice = () => {
    axios
    .post(`${process.env.REACT_APP_API ? process.env.REACT_APP_API : window.location.origin}/gui/v1/ha_device/${deviceID}.json`, {
      customer_id: customer.id
    })
    .then(({ data }) => {
      getCustomer()
      getUnassignedDevices();
    })
    
  }

  const gridOptions = {
    getRowId(data) {
      console.log(data)
      return data.data.id;
    },
    paginationPageSize: 32,
    columnDefs: [
      {
        headerName: "Name",
        cellRenderer: function(params) {
          return (<a href={`/hadevice/${params.data.id}`}>{params.data.name}</a>)
        }  
      }, {
        headerName: "URL",
        cellRenderer: function(params) {
          return (<a href={`${params.data.url}`} target="_blank">{params.data.url}</a>)
        }
      }, {
        headerName: "Active",
        field: "active"
      }, {
        headerName: "IP Address",
        field: "ipaddress"
      }
    ]
  }

  useEffect(() => {
    getCustomer();
    getUnassignedDevices();
  }, []);
  
if (!customer) {
  return <LoadingSpinner />
}

  return (
    <div>
      <h1>{customer.first_name} {customer.surname}</h1>
      <p>E-mail {customer.email}</p>
      <p>Address: {customer.address}</p>
      <h2>Devices</h2>
      <InputGroup>
        <>
        <Form.Select aria-label="Select Device" onChange={(e) => setDeviceID(parseInt(e.target.value))}>
          <option>-- Select Device --</option>
          {unassignedDevices ? unassignedDevices.map((device) => (<option key={device.id} value={device.id}>{device.name}</option>)) : <option>NO Free Devices</option>}
        </Form.Select>
        </>
        <Button variant="primary" onClick={() => assignDevice()} disabled={deviceID ? false : true}>Assign</Button>
      </InputGroup>
      <Table gridOptions={gridOptions} rowData={customer.ha_devices} />
    </div>
  )
}

export default CustomerShow;